import register from 'preact-custom-element'
import ProductCard from 'snippets/product-card/product-card'
import { getProductTitle } from 'libs/shopify'

function ProductRelated({ title, soldOutLabel }) {
  return (
    <div className="pt-6 pb-4 md-max:relative md-max:before:absolute md-max:before:border-t md-max:before:top-0 md-max:before:-left-4 md-max:before:w-[calc(100%_+_32px)] lg:pb-8">
      <h6 className="text-xl text-grey-1000 mb-4 ">{title}</h6>
      <div className="relative w-full">
        {relatedProducts.map((product) => (
          <ProductCard
            title={getProductTitle(product.title)}
            handle={product.handle}
            imageUrl={[product.featuredImage]}
            variants={product.variants}
            size={product.metafields.sizes}
            className="relative flex items-start mb-4 bg-white rounded last:mb-0"
            classImageWrapper="relative w-[80px] min-w-[80px]"
            isCover
            soldOutLabel={soldOutLabel}
          />
        ))}
      </div>
    </div>
  )
}

register(ProductRelated, 'product-related', ['title', 'soldOutLabel'])
